import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Palette, Users } from 'lucide-react';

const tabs = [
  { path: '/art', label: 'Art', icon: Palette },
  { path: '/circles', label: 'Circles', icon: Users },
];

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = tabs.find((t) => location.pathname.startsWith(t.path))?.path || '/art';

  return (
    <Container>
      <Content>
        <Outlet />
      </Content>
      <TabBar>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.path;
          return (
            <Tab key={tab.path} $active={isActive} onClick={() => navigate(tab.path)}>
              <Icon size={22} strokeWidth={isActive ? 2.5 : 1.5} />
              <TabLabel>{tab.label}</TabLabel>
            </Tab>
          );
        })}
      </TabBar>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
  position: relative;
  padding-top: env(safe-area-inset-top, 0px);
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
`;

const TabBar = styled.nav`
  display: flex;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surfaceElevated};
  padding-bottom: env(safe-area-inset-bottom, 0);
  flex-shrink: 0;
`;

const Tab = styled.button`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 10px 0 6px;
  min-height: 50px;
  color: ${({ $active, theme }) => ($active ? theme.colors.accent : theme.colors.textTertiary)};
  transition: color 0.2s;
`;

const TabLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
`;
